export default "<app-user-form (onsubmit)=\"save($event)\" (onDelete)=\"delete($event)\" [user]=\"user\"></app-user-form>\n";